import { useContext } from 'react';
import ConfigsContext from "../contexts/DocumentsAppConfigsContext.js";

var useDocumentsAppConfigs = function useDocumentsAppConfigs() {
  var configs = useContext(ConfigsContext);

  if (!configs) {
    throw new Error('documents_app configs not found');
  }

  return configs;
};

export default useDocumentsAppConfigs;